import React from "react";

const Clinical = () => {
  return (
    <div className="bg-white max-w-[460px] text-teal-300 ">
      <h3 className="flex items-center justify-center bg-gray-20 p-6 text-center font-semibold text-md-body">
        Up-To-Date Claims
      </h3>
      <div className="flex flex-col items-stretch gap-4 text-left">
        <p className="text-body-sm gap-4 p-6 text-left">
          <b>Drug Profile Viewer  will not list medications or services paid by cash or private plans. </b>
          <br/>
          <br />
          Pharmacies should be connected to a "Provincial Clinical Viewer" to
          access the professional service history in the clinical viewer to
          comply with claim maximums, or verify through an alternate means and
          document appropriately. (Ref. Ministry of Health, Health Programs and
          Delivery Division)
        </p>
      </div>
    </div>
  );
};

export default Clinical;
